import { RenderElementProps } from 'slate-react';
import { useDiff } from 'app/state/contexts/DiffContext';
import { getDiffClass, getNodeId, DiffState } from 'slate/compareUtils';

type DiffedElementProps = RenderElementProps & {
  side?: 'left' | 'right';
  readOnly?: boolean;
  renderElement: (elementProps: RenderElementProps & { diff?: unknown; extraOffset?: number }) => JSX.Element;
};

const DiffedElement = (props: DiffedElementProps) => {
  const { renderElement, side = 'left', element } = props;
  const { diffState } = useDiff();
  const diffs = (diffState as DiffState)[side];
  const change = diffs[getNodeId(element)];

  if (change?.state === 'missing') {
    return <div className={`diffed-${element.type} diffed-${getDiffClass(side)}`}>{renderElement({ ...props, diff: change?.computedDiff })}</div>;
  }

  if (change?.type === 'page') {
    return renderElement({ ...props, extraOffset: change.offset });
  }

  return renderElement({ ...props, diff: change?.computedDiff });
};

export default DiffedElement;
